import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useKpi from '../useKpi';
import AlertMessage from '../../../components/alertMessage';
import UIHelper from '../../../../../helpers/UIHelper';

const MainPage = () => {
  const {
    data,
    filters,
    summary,
    summary2,
    summary3,
    title,
    loading,
    handleDownloadExcel,
    searchParams,
    loadingPdf,
    handleDownloadPdf,
    errors,
  } = useKpi();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('Overview KPIs').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage errors={errors} searchParams={searchParams} />
        <Spin spinning={loading}>
          <Row className={styles.titleSection} justify={'center'}>
            <Col>
              <Typography.Title level={3}>{title}</Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(data.table1.columns)}
                dataSource={data.table1.data}
                summary={summary}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                loading={loading}
              />
            </Col>
            <Divider />
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(data.table2.columns)}
                dataSource={data.table2.data}
                summary={summary2}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                loading={loading}
              />
            </Col>
            <Divider />
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(data.table3.columns)}
                dataSource={data.table3.data}
                summary={summary3}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                loading={loading}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default MainPage;
